import {ChatBotMessage} from "./ChatBotMessage";
export default ChatBotMessage;